export enum BuildRentType {
    BuildRent = 0,
    FixRent = 1,
}

export const BuildRentTypeOptions = [
    {
        id: BuildRentType.BuildRent,
        question: 'Yes (New Square Footage)',
        name: 'Build-Rent',
        shortName: 'Bld-Rent',
    },
    {
        id: BuildRentType.FixRent,
        question: 'No (Just Renovating Existing)',
        name: 'Fix-Rent',
        shortName: 'Fix-Rent',
    },
];
